module.exports = __webpack_public_path__ + "resources/icon_32_setting.1aea77794de60d4d.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_32_setting.png
// module id = 451
// module chunks = 0 1 2 3 4